<main class="main-content">
  <router-outlet />
</main>
<app-footer />
